import { render, staticRenderFns } from "./AppSwitch.vue?vue&type=template&id=feee12b2&"
import script from "./AppSwitch.vue?vue&type=script&lang=ts&"
export * from "./AppSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./AppSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
